import { render, staticRenderFns } from "./PromotionShop.vue?vue&type=template&id=677cc6c6"
import script from "./PromotionShop.vue?vue&type=script&lang=js"
export * from "./PromotionShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports